import React from "react";

export default function Footer({
  privacyUrl = "/privacy",
  termsUrl = "/terms",
  contactUrl = "/contact",
  className = "",
}) {
  const year = new Date()?.getFullYear();
  return (
    <footer
      className={`w-full border-t border-gray-200 dark:border-gray-800 bg-white/70 dark:bg-neutral-950/70 backdrop-blur px-4 md:px-6 py-6 ${className}`}
      aria-label="Site footer"
    >
      <div className="mx-auto max-w-6xl flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="text-sm text-gray-600 dark:text-gray-400 text-center md:text-left">
          <p className="mb-1">
            © {year} Epoxy Dogs LLC. <span className="font-semibold">SkillBinder</span>
            <span className="align-super text-[10px] ml-0.5">™</span> is a trademark of Epoxy Dogs LLC. All rights reserved.
          </p>
          <p>
            Contact us: <a 
              href="mailto:support@skillbinder.com" 
              className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 underline-offset-4 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 rounded"
            >
              support@skillbinder.com
            </a>
          </p>
        </div>

        <nav className="flex items-center gap-4 text-sm">
          <a
            href={privacyUrl}
            className="text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 underline-offset-4 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 rounded"
          >
            Privacy Policy
          </a>
          <span className="hidden md:inline text-gray-400">|</span>
          <a
            href={termsUrl}
            className="text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 underline-offset-4 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 rounded"
          >
            Terms of Service
          </a>
          <span className="hidden md:inline text-gray-400">|</span>
          <a
            href={contactUrl}
            className="text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 underline-offset-4 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 rounded"
          >
            Contact Us
          </a>
        </nav>
      </div>
    </footer>
  );
}